import React, { Component } from "react";
import MyProvider from "./contexts/MyProvider";
import "./custom.css";
import "./styles/main.scss";
import { TrainAdminSwitch } from "./infrastructure/TrainAdminSwitch";
import { TrainDefaultSwitch } from "./infrastructure/TrainDefaultSwitch";
import { TrainCustomerServiceSwitch } from "./infrastructure/TrainCustomerServiceSwitch";

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    this.state = {
      mode: "",
      firstLoad: true,
      allowFileUploadExtension: [],
      totalCostSEKMax: "",
    };
  }

  render() {
    this.state.mode = window.__RUNTIME_CONFIG__.Mode;

    if (this.state.mode != "") {
      switch (this.state.mode) {
        case "admin":
          return (
            <MyProvider {...this.state}>
              <TrainAdminSwitch />
            </MyProvider>
          );
        case "portal":
        case "public":
          return (
            <MyProvider {...this.state}>
              <TrainDefaultSwitch />
            </MyProvider>
          );
        case "customer-service":
          return (
            <MyProvider {...this.state}>
              <TrainCustomerServiceSwitch />
            </MyProvider>
          );
        default:
          break;
      }
    }
    return "";
  }
}
